'use client';

import { motion } from 'motion/react';

import { Marquee } from '~/components/fragments/marquee';

const brands = [
  { name: 'Cummins', logo: '/assets/brands/cummins.svg' },
  { name: 'Accenture', logo: '/assets/brands/accenture.svg' },
  { name: 'NTT DATA', logo: '/assets/brands/ntt-data.svg' },
  { name: 'Lucid Motors', logo: '/assets/brands/lucid-motors.svg' },
  { name: 'Stanford', logo: '/assets/brands/stanford.svg' },
  { name: 'University of Utah', logo: '/assets/brands/university-of-utah.png' },
  {
    name: 'Booz Allen Hamilton',
    logo: '/assets/brands/booz-allen-hamilton.svg'
  }
];

export default function TrustedBy() {
  return (
    <motion.section
      id="trusted-by"
      className="py-10 md:py-14"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <p className="mb-8 text-center text-xs sm:text-sm font-medium uppercase tracking-wider text-muted-foreground">
          Used by people at
        </p>

        <div className="relative">
          {/* Edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-background to-transparent sm:w-24" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-background to-transparent sm:w-24" />

          <Marquee
            pauseOnHover
            className="[--duration:35s] [--gap:3rem] sm:[--gap:4.5rem]"
          >
            {brands.map((brand) => (
              <img
                key={brand.name}
                src={brand.logo}
                alt={brand.name}
                className="h-7 md:h-8 w-auto max-w-[130px] object-contain opacity-60 grayscale transition duration-300 hover:opacity-100 dark:opacity-70 dark:invert"
                loading="lazy"
              />
            ))}
          </Marquee>
        </div>
      </div>
    </motion.section>
  );
}
